const localeTexts = {
  configFields: {
    field1: {
      label: "Config Field 1",
      help: "Help text for field 1",
      placeholder: "Field 1",
      instruction: "Instruction for field 1",
    },
  },
  customField: {
    placeHolder: "Enter your name",
    instruction: "Pick a Color",
  },
  sidebarWidget: {
    titleCaption: "Title - ",
  },
};

export default localeTexts;
